import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  accountId,
  focusAfterTimeout,
} from '../../util';

import { getIcon } from '../../util/icons';

import { NumericalInput } from '../shared';

import Select from 'react-select';

import moment from 'moment';

import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';

import {
  createSalesforceDeal
} from '../../actions/integrations/salesforce';

const DEFAULT_DEAL_STAGES = [{
  label: 'Open',
  value: 'open',
  status: 'open',
},{
  label: 'Won',
  value: 'won',
  status: 'won',
},{
  label: 'Lost',
  value: 'lost',
  status: 'lost',
}];

const DEFAULT_DEAL = {
  name: '',
  estimatedValue: '',
  estimatedCloseDate: moment().valueOf(),
  product: '',
  status: 'open',
}

class CreateSalesforceDealModal extends Component{

  state = {
    deal: DEFAULT_DEAL,
    saving: false,
    error: null,
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.visible && !this.props.visible){
      focusAfterTimeout(this, 'dealNameInput');
    }
    if(nextProps.editingDeal){
      this.setState({
        deal: nextProps.editingDeal,
      });

      console.log('editingDeal: ', nextProps.editingDeal);
    }
  }

  updateDealProps(props){
    this.setState({
      deal: {
        ...this.state.deal,
        ...props
      }
    });
  }

  updateDealProp(propName, propValue){
    this.setState({
      deal: {
        ...this.state.deal,
        [propName]: propValue
      }
    });
  }

  clearError(){
    this.setState({
      error: null,
    });
  }

  createSalesforceDeal(){

    if(this.state.saving){
      return;
    }

    this.setState({
      saving: true
    });

    createSalesforceDeal(this.state.deal, this.onCreate.bind(this));
  }

  onCreate(res){
    if(!res.success){
      this.setState({
        saving: false,
        error: res.error
      });
    }
    else{
      this.setState({
        saving: false
      }, () => {
        this.props.onCreate(res.data);
      });
    }
  }

  renderFormMessage(){
    if(this.state.error){
      return <div className="form-message error">{this.state.error}</div>;
    }
    else{
      return null;
    }
  }

  formIsDirty(){

    const {
      _id,
      name,
      product,
      estimatedValue,
      estimatedCloseDate,
      status,
      sf,
    } = this.props.editingDeal;

    if( !_id ||
      name !== this.state.deal.name ||
      estimatedValue !== this.state.deal.estimatedValue ||
      estimatedCloseDate !== this.state.deal.estimatedCloseDate ||
      product !== this.state.deal.product ||
      status !== this.state.deal.status
     ){
       return true;
     }
    else{
      return false;
    }
  }

  getOptionForValue(options, value){
    return _.find(options, option => {
      return option.value === value;
    });
  }

  formIsValid(){
    const {
      _id,
      name,
      product,
      estimatedValue,
      estimatedCloseDate,
      stage,
    } = this.state.deal;

    return  name &&
            name !== '' &&
            estimatedValue &&
            estimatedValue !== '' &&
            estimatedCloseDate &&
            estimatedCloseDate !== '' &&
            stage &&
            stage !== '';
  }

  renderDealStageSelect(){
    const {
      stage,
      status
    } = this.state.deal;

    const stageOptions = this.props.organization && this.props.organization.dealStages || DEFAULT_DEAL_STAGES;

    return (
      <Select
        classNamePrefix={'react-select'}
        className='react-select-container deal-status'
        value={this.getOptionForValue(stageOptions, stage)}
        options={stageOptions}
        onChange={(option) => { this.updateDealProps({ stage: option.value, status: option.status}); } }
        isSearchable={true}
      />
    )
  }

  renderDealForm(){

    const {
      _id,
      name,
      product,
      estimatedValue,
      estimatedCloseDate,
      status,
    } = this.state.deal;

    const { viewingUser } = this.props;

    const estimatedCloseDateMoment = moment(estimatedCloseDate);

    return(
      <form className="velocity-form">
        <h2>Add new deal</h2>
        <p className="subheading">This new deal will also be synced to SalesForce upon creation</p>
        {viewingUser && accountId() !== viewingUser.uid &&
          <p className="subheading">{getIcon('info-bold')} Adding deal on behalf of {viewingUser.firstName} {viewingUser.lastName}</p>
        }
        {this.renderFormMessage()}
        <div className="form-group">
          <div className="input-group">
            <label htmlFor="deal-name">Deal Name</label>
            <input
              ref={input => { this.dealNameInput = input; }}
              id="deal-name"
              className="fs-block"
              autoComplete="off"
              type="text"
              value={name || ''}
              onChange={e => { this.updateDealProp('name', e.target.value); }}
              />
          </div>
        </div>
        <div className="form-group">
          <div className="input-group full-width">
            <label htmlFor="deal-name">Deal stage</label>
            {this.renderDealStageSelect()}
          </div>
        </div>
        <div className="form-group">
          <div className="input-group third-width">
            <label htmlFor="deal-product">Product or Service</label>
              <input
                id="deal-product"
                autoComplete="off"
                type="text"
                value={product || ''}
                onChange={e => { this.updateDealProp('product', e.target.value); }}
                />
          </div>
          <div className="input-group fs-block third-width">
            <label htmlFor="deal-close">Estimated close date</label>
            <SingleDatePicker
              hideKeyboardShortcutsPanel={true}
              date={estimatedCloseDateMoment}
              onDateChange={date => { this.updateDealProp('estimatedCloseDate', date ? date.valueOf() : null); }}
              id="update-deal-estimated-close-date"
              focused={this.state.estimatedClosedDatePickerFocused}
              onFocusChange={({focused}) => { this.setState({ estimatedClosedDatePickerFocused: focused }); }}
              />
          </div>
          <div className="input-group fs-block third-width">
            <label htmlFor="deal-value">Estimated value</label>
            <NumericalInput
              id="deal-value"
              formatThousands={true}
              value={estimatedValue || ''}
              onUpdate={val => { this.updateDealProp('estimatedValue', val); }}
            />
          </div>
        </div>
      </form>
    )
  }

  renderActions(){
    const {
      saving
    } = this.state;

    const {
      source
    } = this.state.deal;

    const formIsValid = this.formIsValid();

    return (
      <React.Fragment>
        <button className="button salesforce-button" onClick={this.createSalesforceDeal.bind(this)} disabled={saving || !formIsValid}>{getIcon('salesforce-outline')}{saving ? 'Syncing...' : 'Create Deal'}</button>
        <button className="button grey-button" onClick={this.props.hide}>Cancel</button>
      </React.Fragment>
    )
  }

  render(){

    if(!this.props.visible){
      return null;
    }

    const { saving } = this.state;

    const formIsValid = this.formIsValid();

    return (
      <div className={`modal update-deal`}>
        <div className="modal-container">
          <div className="close-icon" onClick={this.props.hide}>X</div>
          <div className="modal-content">
            {this.renderDealForm()}
          </div>
          <div className="modal-actions">
            {!this.formIsDirty() && !saving &&
              <button className="button primary" onClick={this.props.hide}>Done</button>
            }
            {(this.formIsDirty() || saving) && this.renderActions()}
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    organization: state.organization.data,
  }
}

export default connect(mapStateToProps, {  })(CreateSalesforceDealModal);



// WEBPACK FOOTER //
// ./src/components/modals/createSalesforceDeal.js